import React, { useEffect, useState } from "react";
import { CgMenuLeftAlt } from "react-icons/cg";
import { useDispatch, useSelector } from "react-redux";
import { rootAction } from "../redux/reducer/rootReducer";
import { Badge, FormControl, MenuItem, Select } from "@mui/material";
import { IoIosAddCircleOutline, IoIosArrowDown, IoIosChatboxes } from "react-icons/io";
import { MdShoppingCart } from "react-icons/md";
import { useNavigate } from "react-router";
import { CalendarAPI } from "../api/CalendarAPI";
import clubLogoImg from "../assets/images/SportMingleLogoMark.png"
import Timer from "../pages/reservation-payment/Timer";
import { isClubOwner, isClubStaff, isCoach, isGuest, isUser } from "../util/UserRoles";
import { setSelectedClub } from "../redux/reducer/userReducer";
import { CoachSchedulerAPI } from "../api/CoachSchedulerAPI";

const Header = () => {
  const userInfo = useSelector((store) => store.user.userInfo);
  const selectedClub = useSelector((store) => store.user.selectedClub);
  const isUpdateTotalSchedule = useSelector((store) => store.root.isUpdateTotalSchedule);
  const openSlideBar = useSelector((store) => store.root.openSlideBar);
  const isPaymentDoneForReservation = useSelector((store) => store.root.isPaymentDoneForReservation);
  const isCheckoutConfigChange = useSelector((store) => store.root.isCheckoutConfigChange);
  const totalUnreadMessage = useSelector((store) => store.chat.totalUnreadMessage);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isCheckoutEnable, setIsCheckoutEnable] = useState(false);
  const [totalPendingReservation, setTotalPendingReservation] = useState(0);

  useEffect(() => {
    if (isUser(userInfo) || isCoach(userInfo)) {
      if (userInfo.userId && selectedClub.clubId) {
        if (selectedClub?.calendarType === 'RESERVATION_CALENDAR'){
          getTotalPendingReservation();
        }else{
          getTotalUnPaidSchedule();
        }
      }
      if (isPaymentDoneForReservation.type == 'created' || isPaymentDoneForReservation.type == 'deleted') {
        dispatch(rootAction.setReservationPaymentStatus(({
          status: false,
          type: 'init'
        })));
      }
    }
    isUpdateTotalSchedule && dispatch(rootAction.setIsUpdateTotalSchedule(false))
  }, [userInfo.userId, selectedClub.clubId, isUpdateTotalSchedule,isPaymentDoneForReservation.type]);


  const getTotalUnPaidSchedule = async () => {
    const response = await CoachSchedulerAPI.findTotalUnPaidSchedule(userInfo.userId,selectedClub.clubId);
    setTotalPendingReservation(response.Data);
  }

  const getTotalPendingReservation = async () => {
    const response = await CalendarAPI.getTotalPendingReservation({
      userId: userInfo.userId,
      clubId: selectedClub.clubId
    });
    if (isPaymentDoneForReservation?.type === 'created') {
      setTotalPendingReservation(response.Data);
      dispatch(rootAction.setIsTimerActive(true));
    } else if (isPaymentDoneForReservation?.type === 'deleted') {
      setTotalPendingReservation(response.Data);
      paymentTimerDetails();
    } else if (isPaymentDoneForReservation?.type === 'payment') {
      setTotalPendingReservation(0);
      dispatch(rootAction.setIsTimerActive(false));
    } else {
      setTotalPendingReservation(response.Data);
      paymentTimerDetails();
    }
  }

  const findCalendarConfigCheckout = async() => {
     try{
      const response = await CalendarAPI.getCalendarConfigCheckout(selectedClub.clubId);
      setIsCheckoutEnable(response.Data);
     }catch(error){
         console.log(error);
     }
  };
  useEffect(() => {
   if(selectedClub.clubId){
    findCalendarConfigCheckout();
   }
   isCheckoutConfigChange && dispatch(rootAction.setIsCheckoutConfigChange(false));
  }, [isCheckoutConfigChange, selectedClub.clubId])
  

  const paymentTimerDetails = async () => {
    try {
      const response = await CalendarAPI.getPaymentTimerDetails({ userId: userInfo?.userId, clubId: selectedClub.clubId });
      if (response?.Data?.reservations?.length != 0) {
        let targetDateWithZone = new Date(new Date(response?.Data?.reservations[0]?.createdDate).toLocaleString('en-US', { timeZone: "UTC" }));
        let targetDate = targetDateWithZone.setMinutes(targetDateWithZone.getMinutes() + 5);
        let currentDate = new Date(new Date().toLocaleString('en-US', { timeZone: "UTC" }));
        dispatch(rootAction.setInitialTimer(Math.floor((targetDate - currentDate) / 1000)));
        if (Math.floor((targetDate - currentDate) / 1000)) {
          if (response?.Data?.reservations[0]?.reservationCreatedBy === userInfo?.userId) {
            dispatch(rootAction.setIsTimerActive(true));
          } else {
            dispatch(rootAction.setIsTimerActive(false));
          }
        }
      } else {
        dispatch(rootAction.setIsTimerActive(false));

      }
    } catch (error) {

    }
  }
  const handleSelectClub = async(val) => {
    if (val !== 'add') {
      const newClub = userInfo.clubs.filter((club) => club.clubId === val);
      dispatch(setSelectedClub(newClub[0]));
    }
  }
  const handleProfileRoute = () => {
    if (!isUser(userInfo)) {
      navigate('/club-setup')
      dispatch(rootAction.setActiveTab({ clubProfile: true }));
    }
  }
  return (
    <div className='root-header-container' data-testid='root-header-container'>
      <div data-testid="root-header-body" className={openSlideBar ? 'root-header-body active' : 'root-header-body'}>
        {
          <div className='root-open-sidebar'>
            <CgMenuLeftAlt onClick={() => { dispatch(rootAction.setOpenSlideBar(!openSlideBar)) }} className='root-open-sidebar-icon' data-testid="root-open-sidebar-icon" />
          </div>}
        {(isUser(userInfo))
          && <Timer />}
        <div data-testid="root_cart_clubname" className="root_cart_clubname">
          <div className="header_club_info">
            <FormControl fullWidth
              className="seleted_club_dropdown"
            >
              <Select
                disabled={isCoach(userInfo) || isClubOwner(userInfo)}
                IconComponent={(isCoach(userInfo) || isClubOwner(userInfo)) ? () => <></> : IoIosArrowDown}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedClub?.clubId}
                size="small"
                MenuProps={{
                  disableScrollLock: true,
                }}
                onChange={(val) => handleSelectClub(val.target.value)}
              >
                {
                  userInfo?.clubs?.map((club, index) =>
                    <MenuItem sx={{
                      '&.Mui-selected': {
                        backgroundColor: 'var(--hoverColorLightest)',
                      },
                      '&.Mui-selected:hover': {
                        backgroundColor: 'var(--hoverColorLight)',
                      },
                    }} key={index} value={club?.clubId}>
                      <div className='header_club_info_item'>
                        <img src={club?.clubLogo ? `${import.meta.env.VITE_APP_BASE_URL}/club/club-logo-img/${club?.clubLogo}` : clubLogoImg} alt="" />
                        <h2 data-testid="club_name" >{club?.clubName}</h2>
                      </div>
                    </MenuItem>
                  )
                }
                <MenuItem value="add">
                  <div className='header_club_info_add_club' onClick={() => navigate("/add-org")}>
                    <IoIosAddCircleOutline className="header_club_info_add_club_icon" />
                    <p>Add Organization</p>
                  </div>
                </MenuItem>
              </Select>
            </FormControl>
          </div>
         {!isGuest(userInfo) &&
           <Badge style={{ marginRight: 13 }} badgeContent={totalUnreadMessage} color="error" >
           <IoIosChatboxes className="sm_header_chat_icon" onClick={() => navigate("/chat")} />
         </Badge>}
          {(selectedClub?.isPlanRequired && isCheckoutEnable && !isClubOwner(userInfo) && !isClubStaff(userInfo)) &&
            <div
              data-testid="cart-container"
              onClick={() =>{
                if (selectedClub?.calendarType === 'RESERVATION_CALENDAR'){
                  navigate('/cart');
                }else{
                  navigate('/schedule-cart');
                }
              
              }}
              className="root_header_cart_conatiner">
              <Badge style={{
                transition: 'transform 0.3s ease', // Optional: smooth transition on hover
              }} badgeContent={totalPendingReservation} color="error">
                <MdShoppingCart className="root_cart_icon" />
              </Badge>
            </div>
          }
        </div>
      </div>
    </div>
  )
};

export default Header;